/** 前端部署版本（YYYYMMDD），发版时更新 */
export const APP_VERSION = '20260909'
